/** Agrupamento de seções do cadastro em abas (padrão ClientDetails). */
export const CLIENT_FORM_TAB_GROUPS = [
  {
    id: "cadastro",
    label: "Cadastro",
    sectionTitles: [
      "Identificação",
      "Dados pessoais",
      "Documentos",
      "Dados empresariais",
      "Vínculo e status",
    ],
  },
  {
    id: "contato",
    label: "Contato e endereço",
    sectionTitles: ["Contato", "Endereço"],
  },
  {
    id: "classificacao",
    label: "Classificação",
    sectionTitles: ["Classificação comercial"],
  },
  {
    id: "perfil",
    label: "Perfil e redes",
    sectionTitles: ["Perfil", "Redes sociais"],
  },
  {
    id: "extras",
    label: "Extras",
    sectionTitles: [],
    includesPortal: true,
    includesCustomFields: true,
  },
];

/** Colunas do grid de 12 para densidade por tipo de campo. */
export function clientFormFieldGridSpan(field) {
  if (field.fullWidth || field.type === "textarea" || field.type === "tags") return 12;
  if (field.type === "boolean") return 12;
  const narrow = new Set([
    "tipo",
    "status",
    "uf",
    "sexo",
    "estado_civil",
    "potencial",
    "score",
    "preferencia_contato",
    "tiposanguineo",
    "cep",
    "numero",
    "complemento",
    "data_abertura",
    "data_nascimento",
  ]);
  if (narrow.has(field.name)) return 4;
  return 6;
}
